import React, { useState, Children } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What age is this for?',
  answer: "The system works perfectly for children from ages 3 to 12+. Because the activities are structured progressively, they easily adapt to your child's current development level."
}, {
  question: 'Do I need special teaching skills?',
  answer: 'Not at all. Everything is print-and-go, simple, guided and easy to follow. Any parent can use it instantly.'
}, {
  question: 'Does it work for children with ADHD or learning difficulties?',
  answer: 'Yes. Hundreds of parents with active, restless or easily distracted children report excellent results. The activities are short, highly engaging and specifically designed to reduce frustration and build focus step-by-step.'
}, {
  question: 'Can I use it for more than one child?',
  answer: 'Absolutely. You buy it once, download the PDF, and you have lifetime access to print it as many times as you need for all your children.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-gray-50" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <div className="text-center mb-12" data-id="element-92">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-93">
            ❓ Frequently Asked Questions
          </h2>
          <div className="w-24 h-2 bg-blue-600 mx-auto rounded-full" data-id="element-94"></div>
        </div>

        <div className="space-y-3" data-id="element-95">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-96">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer" data-id="element-97">
                <span className="text-lg md:text-xl font-bold text-gray-900 pr-4" data-id="element-98">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 md:w-6 md:h-6 text-gray-500 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-99" />
              </button>
              {openIndex === index && <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-100">
                  <p className="text-base md:text-lg text-gray-600 font-medium leading-relaxed" data-id="element-101">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}